import { makeOfferUpdateOperation } from './makeOfferUpdateOperation';
import { DirtyFieldsType, Operation } from '../types';
import { isFieldDirty } from '../utils';

type FulfillmentPriorityValues = {
  fulfillmentPriorityLevel?: number | null;
};

// Save path for Offer Fulfillment Priority (OCST-28864). Shared across all in-scope
// campaign components; called from each component's configure-form operations. Emits an
// offer-update operation only when the field is dirty. Value persisted as-is (no transform).
export const getOfferFulfillmentPriorityUpdateOperations = (
  offerId: string,
  values: FulfillmentPriorityValues,
  dirtyFields: DirtyFieldsType,
): Operation[] => {
  if (!isFieldDirty<FulfillmentPriorityValues>(dirtyFields, 'fulfillmentPriorityLevel')) {
    return [];
  }

  return [
    makeOfferUpdateOperation(offerId, {
      fulfillmentPriorityLevel: values.fulfillmentPriorityLevel ?? null,
    }),
  ];
};
